import { camelCase, kebabCase } from 'lodash';
import { StepName } from '../step.interface';

export const mapStepNameToStepRoute = (stepName: StepName) => kebabCase(stepName) || stepName;

export const mapStepRouteToStepName = (stepRoute: string) => camelCase(stepRoute) || stepRoute;
